import { forRails } from 'components/for-rails'
import { WinDashboard } from 'components/win-dashboard'
import { HomePage } from '../src/pages/home-page'
import { registerComponents } from '../src/utils/react/registry'

registerComponents({
  HomePage: forRails(HomePage),
  WinDashboard: forRails(WinDashboard),
})
